import React from 'react';
import { Menu } from 'lucide-react';
import { DocFinderIcon } from '../../components/ui/doc-finder-icon';

interface TopBarProps {
  title: string;
  subtitle?: string;
  onSearch?: (query: string) => void;
  onMenuToggle?: () => void;
}

export const TopBar: React.FC<TopBarProps> = ({ title, subtitle, onSearch, onMenuToggle }) => {
  return (
    <div className="h-16 bg-card border-b border-border flex items-center justify-between px-6">
      <div className="flex items-center gap-4">
        {/* Hamburger Menu Button - Only visible on mobile/tablet/iPad Pro */}
        <button
          onClick={onMenuToggle}
          className="p-2 rounded-lg hover:bg-accent xl:hidden"
        >
          <Menu className="h-5 w-5" />
        </button>
        
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center text-primary-foreground">
            <DocFinderIcon size="sm" />
          </div>
          <div>
            <h1 className="text-xl font-semibold text-foreground">{title}</h1>
            {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
          </div>
        </div>
      </div>
      
      {/* <div className="flex items-center gap-4">
        
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Search providers..."
            className="pl-10 w-64 bg-background"
          />
        </div>
        
      </div> */}
    </div>
  );
};
